import { Component, Input, Output, EventEmitter } from '@angular/core';

import { GridColumn } from '../column-visibility-toggle/column-visibility-toggle.component';

@Component({
  selector: 'app-column-search-row',
  standalone: true,
  imports: [],
  template: `
    @if (showColumnFilters) {
      <div
        class="column-search-row"
        [style.gridTemplateColumns]="filterRowGridTemplate">
        <!-- Empty placeholder for checkbox column (aligns with table) -->
        @if (showCheckboxPlaceholder) {
          <div class="column-search-input"></div>
        }
        <!-- Dynamic filter inputs based on visible columns -->
        @for (col of visibleColumns; track col) {
          <div class="column-search-input">
            <input
              type="text"
              [placeholder]="placeholder(col.header)"
              [value]="columnFilters[col.field] || ''"
              (input)="onSearch(col.field, $any($event.target).value)"
              [attr.aria-label]="'Search by ' + col.header" />
            @if (columnFilters[col.field]) {
              <button
                (click)="onClear(col.field)"
                class="clear-column-filter"
                [attr.aria-label]="'Clear ' + col.header + ' search'">
                ✕
              </button>
            }
          </div>
        }
      </div>
    }
  `,
  styles: [
    `
      .column-search-row {
        display: grid;
        gap: 8px;
        padding: 12px 25px;
        background: var(--ukg-gray-50, #f9fafb);
        border-bottom: 1px solid var(--ukg-gray-200, #e5e7eb);
        flex-shrink: 0;
        align-items: center;
      }

      .column-search-input {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        min-width: 0;
        padding: 0;
      }

      .column-search-input input {
        width: 100%;
        padding: 10px 24px 8px 10px;
        border: 1px solid var(--ukg-gray-300, #d1d5db);
        border-radius: 4px;
        font-size: 13px;
        background: white;
        color: var(--ukg-gray-900, #1a1a2e);
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
        transition: all 0.2s;
        box-sizing: border-box;
        min-width: 0;
      }

      .column-search-input input::placeholder {
        color: var(--ukg-gray-400, #9ca3af);
      }

      .column-search-input input:hover {
        border-color: var(--ukg-gray-400, #9ca3af);
      }

      .column-search-input input:focus {
        outline: none;
        border-color: var(--ukg-blue-500, #3b82f6);
        box-shadow: 0 0 0 3px var(--ukg-blue-100, #dbeafe);
      }

      .clear-column-filter {
        position: absolute;
        right: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        padding: 0;
        border: none;
        border-radius: 50%;
        background: transparent;
        color: var(--ukg-gray-500, #6b7280);
        cursor: pointer;
        font-size: 16px;
        transition: all 0.15s;
      }

      .clear-column-filter:hover {
        background: var(--ukg-gray-200, #e5e7eb);
        color: var(--ukg-gray-700, #374151);
      }
    `,
  ],
})
export class ColumnSearchRowComponent {
  @Input() visibleColumns: GridColumn[] = [];
  @Input() columnFilters: Record<string, string> = {};
  @Input() showColumnFilters = false;
  @Input() filterRowGridTemplate = '';
  @Input() showCheckboxPlaceholder = true;
  @Output() columnSearch = new EventEmitter<{
    column: string;
    value: string;
  }>();
  @Output() clearFilter = new EventEmitter<string>();

  placeholder(header: string): string {
    return `${header}...`;
  }

  onSearch(column: string, value: string): void {
    this.columnSearch.emit({ column, value });
  }

  onClear(column: string): void {
    this.clearFilter.emit(column);
  }
}
